import { render, staticRenderFns } from "./AgDetail.vue?vue&type=template&id=48063a16&scoped=true"
import script from "./AgDetail.vue?vue&type=script&lang=js"
export * from "./AgDetail.vue?vue&type=script&lang=js"
import style0 from "./AgDetail.vue?vue&type=style&index=0&id=48063a16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48063a16",
  null
  
)

export default component.exports